export const SIDE_NAV_DRAWER_WIDTH = 270
export const MIN_SCREEN_SIZE = 1200
